import { ThemeProvider, createTheme } from "@mui/material/styles";
import { ptBR } from "@mui/material/locale";
import { DataGrid } from "@mui/x-data-grid";
import { Stack } from "@mui/material";

const theme = createTheme(ptBR);

export interface IProps {
    columns: any;
    rows: any[];
    rowId: any;
    isLoading?: boolean;
    initialState?: any;
    checkboxSelection?: boolean;
    onRowSelectionModelChange?: any;
    rowSelectionModel?: any;
}

export default function DataTable(props: IProps) {
    return (
        <ThemeProvider theme={theme}>
            <DataGrid
                columns={props.columns}
                rows={props.rows}
                getRowId={props.rowId}
                loading={props.isLoading}
                checkboxSelection={props.checkboxSelection}
                onRowSelectionModelChange={props.onRowSelectionModelChange}
                rowSelectionModel={props.rowSelectionModel}
                rowsPerPageOptions={[10, 25, 50, 100]}
                pagination
                localeText={{
                    columnHeaderSortIconLabel: "Ordenar",
                    footerRowSelected: (count) =>
                        count > 1 ? `${count} linhas selecionadas` : `${count} linha selecionada`,
                }}
                components={{
                    NoResultsOverlay: () => (
                        <Stack height="100%" alignItems="center" justifyContent="center">
                            Nenhum resultado encontrado!
                        </Stack>
                    ),
                    NoRowsOverlay: () => (
                        <Stack height="100%" alignItems="center" justifyContent="center">
                            Nenhum registro
                        </Stack>
                    ),
                }}
            />
        </ThemeProvider>
    );
}
